const orderRoutes = [
  {
    path: '/system-setting',
    name: 'SystemSetting',
    meta: {
      index: 1
    },
    component: () => import('@/views/my/Setting.vue')
  },
  {
    path: '/my/app',
    name: 'MyApp',
    meta: {
      index: 2
    },
    component: () => import('@/views/my/App.vue')
  },
  {
    path: '/my/account',
    name: 'MyAccount',
    meta: {
      index: 2
    },
    component: () => import('@/views/my/account/Index.vue')
  },
  {
    path: '/my/account/cancel',
    name: 'MyAccountCancel',
    meta: {
      index: 3
    },
    component: () => import('@/views/my/account/Cancel.vue')
  },
  {
    path: '/my/privacy/center',
    name: 'MyPrivacyCenter',
    meta: {
      index: 2
    },
    component: () => import('@/views/my/privacyCenter/Index.vue')
  },
  {
    path: '/my/privacy/policy',
    name: 'MyPrivacyPolicy',
    meta: {
      index: 3
    },
    component: () => import('@/views/my/privacyCenter/Policy.vue')
  },
  {
    path: '/my/privacy/register',
    name: 'MyPrivacyRegister',
    meta: {
      index: 3
    },
    component: () => import('@/views/my/privacyCenter/Register.vue')
  },
  {
    path: '/my/privacy/third-party',
    name: 'MyPrivacyThirdParty',
    meta: {
      index: 3
    },
    component: () => import('@/views/my/privacyCenter/ThirdParty.vue')
  },
  {
    path: '/my/privacy/auth',
    name: 'MyPrivacyAuth',
    meta: {
      index: 3
    },
    component: () => import('@/views/my/privacyCenter/Authorization.vue')
  },
  {
    path: '/order-list',
    name: 'OrderList',
    meta: {
      index: 10
    },
    component: () => import('@/views/my/order/List.vue')
  },
  {
    path: '/my/quota',
    name: 'MyQuota',
    meta: {
      index: 35
    },
    component: () => import('@/views/my/quota/Index.vue')
  },
  {
    path: '/my/quota-detail',
    name: 'MyQuotaDetail',
    meta: {
      index: 58
    },
    component: () => import('@/views/my/quota/Detail.vue')
  },
  {
    path: '/my/bankcard',
    name: 'MyBankcard',
    meta: {
      index: 142
    },
    component: () => import('@/views/my/bankCard/Index.vue')
  },
  {
    path: '/my/bankcard/add',
    name: 'MyBankcardAdd',
    meta: {
      index: 143
    },
    component: () => import('@/views/my/bankCard/Add.vue')
  },
  {
    path: '/my/bill',
    name: 'MyBill',
    meta: {
      index: 120
    },
    component: () => import('@/views/my/bill/Index.vue')
  },
  {
    path: '/my/bill/repayment',
    name: 'MyBillRepayment',
    meta: {
      index: 121
    },
    component: () => import('@/views/my/bill/repayment.vue')
  },
  {
    path: '/my/bill/pay',
    name: 'MyBillPay',
    meta: {
      index: 122
    },
    component: () => import('@/views/my/bill/pay.vue')
  },
  {
    path: '/my/bill/payCash',
    name: 'MyBillPayCash',
    meta: {
      index: 122
    },
    component: () => import('@/views/my/bill/payCash.vue')
  },
  {
    path: '/my/bill/pay-result',
    name: 'MyBillPayResult',
    meta: {
      index: 123
    },
    component: () => import('@/views/my/bill/payResult.vue')
  },
  {
    path: '/my/otayonii',
    name: 'MyOtayonii',
    meta: {
      index: 50
    },
    component: () => import('@/views/my/otayonii/Index.vue')
  },
  {
    path: '/my/otayonii/withdrawal',
    name: 'MyOtayoniiWithdrawal',
    meta: {
      index: 51
    },
    component: () => import('@/views/my/otayonii/Withdrawal.vue')
  },
  {
    path: '/my/address',
    name: 'MyAddress',
    meta: {
      index: 150
    },
    component: () => import('@/views/my/address/Index.vue')
  },
  {
    path: '/my/address-form',
    name: 'MyAddressForm',
    meta: {
      index: 155
    },
    component: () => import('@/views/my/address/Form.vue')
  },
  {
    path: '/my/goods-order',
    name: 'MyGoodsOrder',
    meta: {
      index: 110
    },
    component: () => import('@/views/my/goodsOrder/Index.vue')
  },
  {
    path: '/my/goods-order-detail',
    name: 'MyGoodsOrderDetail',
    meta: {
      index: 115
    },
    component: () => import('@/views/my/goodsOrder/Detail.vue')
  },
  {
    path: '/my/order-logistics',
    name: 'MyOrderLogistics',
    meta: {
      index: 118
    },
    component: () => import('@/views/my/goodsOrder/Logistics')
  },
  {
    path: '/my/after-sales',
    name: 'MyAfterSales',
    meta: {
      index: 120
    },
    component: () => import('@/views/my/afterSales/Index.vue')
  },
  {
    path: '/my/after-sales-form',
    name: 'MyAfterSalesFrom',
    meta: {
      index: 125,
      title: '申请退款'
    },
    component: () => import('@/views/my/afterSales/Form.vue')
  },
  {
    path: '/my/after-sales-detail',
    name: 'MyAfterSalesDetail',
    meta: {
      index: 130,
      title: '服务单详情'
    },
    component: () => import('@/views/my/afterSales/Detail.vue')
  },
  {
    path: '/my/voucher',
    name: 'MyVoucher',
    meta: {
      index: 34,
      title: '我的券票'
    },
    component: () => import('@/views/my/coupon/voucher/Index')
  }
]
export default orderRoutes
